import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Loading from "../components_root/loading";
import Error_page from './error'; 
import Cookies from "js-cookie";  
import Status_page from '../status_root/status';
import Home_page from '../status_root/home';
import Profile_status from '../status_root/profile_status';
export default function Idpage() {
  const { id } = useParams(); // this will now be your slug
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [statusmooddata, setStatusmooddata] = useState(null);  
    const [accountdata, setAccountdata] = useState(null);  
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      setError(false);
   
       
      try {
          
        const statusmoodSnap = await getDocs(
          query(collection(db, "statusmessage"), where("contentid", "==", id))
        );

        if (!statusmoodSnap.empty) {
          if (!cancelled) {
           setStatusmooddata({ ...statusmoodSnap.docs[0].data(), uid: statusmoodSnap.docs[0].id });
          }
          return;
        }
        //accounts Profile_status username
           const accountsSnap = await getDocs(
          query(collection(db, "accounts"), where("username", "==", id))
        );

        if (!accountsSnap.empty) {
          if (!cancelled) {
          setAccountdata({ ...accountsSnap.docs[0].data(), uid: accountsSnap.docs[0].id });
          }
          return;
        }

        // If neither found
        if (!cancelled) setError(true);
      } catch (err) {
        console.error("Error fetching data for Idpage:", err);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    if (id) {
      fetchData();
    } else {
      // no id param -> show home (clear loading)
      setLoading(false);
      setError(false); 
    }

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <div className="container_roots"><Loading /></div>;
    if (statusmooddata) return <Status_page data={statusmooddata} />; 
      if (accountdata) return <Profile_status data={accountdata} />; 
  if (error) return <Error_page />;

  return <Home_page />;
}